export default "__VITE_ASSET__OPgqXnrjQmfLF9Ge9Zf_SQ__"